import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import Campus2Training from './pages/Campus2Training';
import ServiceRequest from './pages/ServiceRequest';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AccountDeletion from './pages/AccountDeletion';
import InternshipsPage from './pages/InternshipsPage';
import InternshipDetailPage from './pages/InternshipDetailPage';
import ProjectsPage from './pages/ProjectsPage';
import TrainingPage from './pages/TrainingPage';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/campus2training" element={<Campus2Training />} />
      <Route path="/training" element={<TrainingPage />} />
      <Route path="/service-request" element={<ServiceRequest />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/account-deletion" element={<AccountDeletion />} />
      <Route path="/internships" element={<InternshipsPage />} />
      <Route path="/internships/:id" element={<InternshipDetailPage />} />
    </Routes>
    </>
  );
}

export default App;
